import { useRef } from "react"
import { useClickOutside } from "@/hooks/useClickOutside"
import { CloseButton } from "./svg/CloseButton"

type DrawerProps = {
  children: React.ReactNode
  open: boolean
  close: () => void
  className?: string
}

const Drawer = ({ children, open, close, className = "" }: DrawerProps) => {
  const drawerRef = useRef<HTMLDivElement>(null)
  useClickOutside(drawerRef, close)

  return (
    <div
      ref={drawerRef}
      className={`fixed bottom-0 w-full max-w-xl flex flex-col justify-center items-center gap-4 p-4 pt-10 rounded-t-2xl bg-zinc-800 border-2 border-zinc-600 z-[100] transition-[all] transition-duration-400 ${
        open ? "translate-y-0" : "translate-y-[150%]"
      } ${className}`}
    >
      <button
        aria-label="Close"
        onClick={close}
        className="absolute right-0 top-0 bg-transparent hover:text-white flex flex-col items-center text-center text-zinc-300 rounded-xl p-4"
      >
        <CloseButton />
      </button>
      {children}
    </div>
  )
}

export default Drawer
